

function initFaqs(scope = document) {
  const lists = scope.querySelectorAll('.ry-faq__list');
  if (!lists.length) return;

  lists.forEach(faqList => {
    if (faqList.dataset.faqInit === 'true') return; // prevent double binding
    faqList.dataset.faqInit = 'true';

    faqList.addEventListener('click', e => {
      const item = e.target.closest('.ry-faq__item');
      if (!item || !faqList.contains(item)) return;

      faqList.querySelectorAll('.ry-faq__item').forEach(i => {
        if (i !== item) i.classList.remove('is-active');
      });

      item.classList.toggle('is-active');
    });
  });
}


document.addEventListener('DOMContentLoaded', () => {
  initFaqs(document);
});


document.addEventListener('shopify:section:load', e => {
  initFaqs(e.target);
});
